import { c as _c } from "react/compiler-runtime";
import { CheckBox, Typography } from "../../atoms";
import { FilterValue, Region } from "@/shared/types/type/search";
import { useSearchUiStore } from "@/features/search/model/ui/store";
import { getRegionAllOption } from "@/features/search-result/lib/regionAllOption";
interface RegionModalContentProps {
  selectedRegion: number;
  selectedSubRegions: FilterValue[];
  setSelectedSubRegions: (selectedSubRegions: FilterValue[]) => void;
  hideRegionAllOption?: boolean;
  regionList?: Region[];
  designVariant?: boolean;
}
const RegionModalContent = t0 => {
  const $ = _c(22);
  const {
    selectedRegion,
    selectedSubRegions,
    setSelectedSubRegions,
    hideRegionAllOption: t1,
    regionList: providedRegions,
    designVariant: t2
  } = t0;
  const hideRegionAllOption = t1 === undefined ? false : t1;
  const designVariant = t2 === undefined ? false : t2;
  const storedRegions = useSearchUiStore(_temp);
  const regionList = providedRegions ?? storedRegions;
  let t3;
  let t4;
  let t5;
  if ($[0] !== designVariant || $[1] !== hideRegionAllOption || $[2] !== regionList || $[3] !== selectedRegion || $[4] !== selectedSubRegions || $[5] !== setSelectedSubRegions) {
    let t6;
    if ($[9] !== selectedRegion) {
      t6 = region => region.id === selectedRegion;
      $[9] = selectedRegion;
      $[10] = t6;
    } else {
      t6 = $[10];
    }
    const parentRegion = regionList.find(t6);
    const rawSubRegions = parentRegion?.children ?? [];
    const subRegions = hideRegionAllOption ? rawSubRegions.slice(1) : rawSubRegions;
    const allLabel = hideRegionAllOption ? undefined : getRegionAllOption(parentRegion);
    const isSubRegionIncluded = _temp2;
    const isAllSelected = allLabel ? isSubRegionIncluded(selectedSubRegions, allLabel) : false;
    let t7;
    if ($[11] !== selectedSubRegions || $[12] !== setSelectedSubRegions) {
      t7 = region_1 => {
        if (isSubRegionIncluded(selectedSubRegions, region_1) && selectedSubRegions.length === 1) {
          setSelectedSubRegions([]);
          return;
        }
        setSelectedSubRegions([region_1]);
      };
      $[11] = selectedSubRegions;
      $[12] = setSelectedSubRegions;
      $[13] = t7;
    } else {
      t7 = $[13];
    }
    const replaceWithSingle = t7;
    const allCheck = () => {
      if (allLabel) {
        replaceWithSingle(allLabel);
      }
    };
    let t8;
    if ($[14] !== replaceWithSingle) {
      t8 = region_2 => {
        replaceWithSingle(region_2);
      };
      $[14] = replaceWithSingle;
      $[15] = t8;
    } else {
      t8 = $[15];
    }
    const checkSubRegions = t8;
    t5 = "min-h-0 w-3/5 flex-1 overflow-y-auto";
    t3 = "flex flex-col";
    t4 = subRegions.map((region_3, index) => {
      const isAllOption = !hideRegionAllOption && index === 0;
      const isChecked = isAllOption ? isAllSelected : isSubRegionIncluded(selectedSubRegions, region_3) && !isAllSelected;
      return <li key={`${region_3.name}-${index}`} className="py-3 pl-4"><label className="flex items-center gap-2 cursor-pointer"><CheckBox checked={isChecked} checkedColor="#6B00D7" checkedImage={designVariant ? "/images/home-v2/region-checked.svg" : undefined} width={designVariant ? 20 : 16} height={designVariant ? 20 : 16} border={{
            color: "#E5E6EB",
            borderWidth: "2px",
            radius: "2px"
          }} onChange={() => isAllOption ? allCheck() : checkSubRegions(region_3)} /><Typography size={16} lineHeight={24}>{region_3.name}</Typography></label></li>;
    });
    $[0] = designVariant;
    $[1] = hideRegionAllOption;
    $[2] = regionList;
    $[3] = selectedRegion;
    $[4] = selectedSubRegions;
    $[5] = setSelectedSubRegions;
    $[6] = t3;
    $[7] = t4;
    $[8] = t5;
  } else {
    t3 = $[6];
    t4 = $[7];
    t5 = $[8];
  }
  let t6;
  if ($[16] !== t3 || $[17] !== t4) {
    t6 = <ul className={t3}>{t4}</ul>;
    $[16] = t3;
    $[17] = t4;
    $[18] = t6;
  } else {
    t6 = $[18];
  }
  let t7;
  if ($[19] !== t5 || $[20] !== t6) {
    t7 = <main className={t5}>{t6}</main>;
    $[19] = t5;
    $[20] = t6;
    $[21] = t7;
  } else {
    t7 = $[21];
  }
  return t7;
};
export default RegionModalContent;
function _temp(state) {
  return state.regionList;
}
function _temp2(regions, region_0) {
  return regions.some(item => item.id === region_0.id);
}